// extracted by mini-css-extract-plugin
module.exports = {"container":"AreapageSituationsLayout_container__RhI_S","situations":"AreapageSituationsLayout_situations__WmAvx"};